module.exports = __webpack_public_path__ + "assets/img/the-buzz.1a4b08cf.svg";